import {FieldName} from '../../../lib/fieldNames'
import type {PaymentMethodWidgetProps as Props} from '../../types'
import {useGetBody} from './useGetBody'

export function usePaymentMethodProps(_: Props) {
  const getBody = useGetBody()

  return {
    fieldName: FieldName.PaymentInfo,
    getBody,
  } as const
}
